const QueryType = {
  SET_PARAMS: 'query/set_params',
  SET_DEPARTURE_PARAMS: 'query/set_departure_params',
  SET_RETURN_PARAMS: 'query/set_return_params',
};

export default QueryType;
